<template>
  <v-layout row wrap class="mb-5">
    <v-flex xs12 class="mb-1">
      <div class="section-header">
        <span v-show="$vuetify.breakpoint.smAndDown">
          <v-icon class="greyIcon">
            adjust
          </v-icon>
        </span>
        <span class="ml-1 label" :class="{'header-label': $vuetify.breakpoint.smAndDown}">
          {{ $t('message.bizgainOnboarding.summaryPage.TargetingDetails') }}
        </span>
      </div>
      <div class="line" v-if="$vuetify.breakpoint.xsOnly" />
    </v-flex>
    <v-flex xs12 class="app-card elevation-3 rounded">
      <div class="app-card-content custom-card-content">
        <v-layout row wrap>
          <v-flex
            xs12
            mb-3
          >
            <v-layout row wrap>
              <v-flex
                xs12
                md3
              >
                <span class="ml-1 label">
                  {{ $t('message.bizgainOnboarding.summaryPage.Gender') }}:
                </span>
              </v-flex>
              <v-flex
                xs12
                md9
                v-if="!isEditGender"
              >
                <v-layout>
                  <v-flex xs1>
                    <v-icon class="greyIcon" v-if="targetingGender == genderTypes['all'].id">
                      wc
                    </v-icon>
                    <v-icon class="greyIcon" v-if="targetingGender == genderTypes['male'].id">
                      man
                    </v-icon>
                    <v-icon class="greyIcon" v-if="targetingGender == genderTypes['female'].id">
                      woman
                    </v-icon>
                  </v-flex>
                  <v-flex xs9>
                    <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                      {{ gender }}
                    </span>
                  </v-flex>
                  <v-flex xs2>
                    <v-icon
                      :class="{ greyIcon: !$vuetify.breakpoint.mdAndUp, themedIcon: $vuetify.breakpoint.mdAndUp}"
                      @click="editGender()"
                    >
                      edit
                    </v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- <v-flex xs12 md3 /> -->
              <v-flex xs12 md9 v-if="isEditGender">
                <v-card class="pt-2 pl-2 pr-2 pb-0 mt-0" :max-width="500">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <image-card-row
                        :col-width="'xs4 md3'"
                        :card-height="$vuetify.breakpoint.xsOnly ? 90 : 130"
                        :objects="genderTypes"
                        :select-card-id="targetingGender"
                        :short-title="true"
                        @selected-card="updateSelectedGender"
                        :img-height="$vuetify.breakpoint.xsOnly ? '25' : '60'"
                        :img-width="$vuetify.breakpoint.xsOnly ? '25' : '60'"
                        :loading="isUpdateGender"
                      >
                        <template v-slot:title="objectiveTitle">
                          {{ $t(objectiveTitle.title) }}
                        </template>
                      </image-card-row>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-btn
                        depressed
                        :disabled="!targetingGender"
                        :loading="isUpdateGender"
                        class="mx-0 next-btn-color next-btn-xs"
                        @click="updateGender()"
                      >
                        {{ $t('message.save') }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            mb-3
          >
            <v-layout row wrap>
              <v-flex
                xs12
                md3
              >
                <span class="ml-1 label">
                  {{ $t('message.bizgainOnboarding.summaryPage.Age') }}:
                </span>
              </v-flex>
              <v-flex
                xs12
                md9
              >
                <v-layout v-if="!isEditAge">
                  <v-flex xs1>
                    <v-icon class="greyIcon">
                      assignment_ind
                    </v-icon>
                  </v-flex>
                  <v-flex xs9>
                    <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                      {{ targetingAgeString }}
                    </span>
                  </v-flex>
                  <v-flex xs2>
                    <v-icon class="editIcon" @click="editTargetingAge()">
                      edit
                    </v-icon>
                  </v-flex>
                </v-layout>
                <v-layout v-if="isEditAge">
                  <v-card class="pa-2" :width="900">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-range-slider
                          :tick-labels="age"
                          v-model="targetingAgeRange"
                          track-color="primary-variation-1"
                          class="px-4 mt-1 age-range-slider"
                          step="1"
                          max="6"
                          min="0"
                          ticks="always"
                          tick-size="2"
                        />
                      </v-flex>
                      <v-flex xs12 md3>
                        <v-btn
                          depressed
                          :disabled="!targetingAgeRange"
                          :loading="isUpdateAge"
                          class="mx-0 next-btn-color next-btn-xs"
                          @click="updateAge()"
                        >
                          {{ $t('message.save') }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            mb-3
          >
            <v-layout row wrap>
              <v-flex
                xs12
                md3
              >
                <span class="ml-1 label">
                  {{ $t('message.bizgainOnboarding.summaryPage.Location') }}:
                </span>
              </v-flex>
              <v-flex
                xs12
                md9
              >
                <v-layout>
                  <v-flex xs1>
                    <v-icon class="greyIcon">
                      place
                    </v-icon>
                  </v-flex>
                  <v-flex xs9>
                    <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                      {{ targetingLocationString }}
                    </span>
                  </v-flex>
                  <v-flex
                    xs2
                  >
                    <v-icon class="editIcon" @click="editTargetingLocationDetails()">
                      edit
                    </v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            mb-1
          >
            <v-layout row wrap>
              <v-flex
                xs12
                md3
              >
                <span class="ml-1 label">
                  {{ $t('message.bizgainOnboarding.summaryPage.AdditionalNotes') }}:
                </span>
              </v-flex>
              <v-flex
                xs12
                md9
              >
                <v-layout v-if="!isEditBreifNote">
                  <v-flex xs1>
                    <v-icon class="greyIcon">
                      note_alt
                    </v-icon>
                  </v-flex>
                  <v-flex xs9>
                    <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                      {{ briefNote }}
                    </span>
                  </v-flex>
                  <v-flex
                    xs2
                  >
                    <v-icon class="editIcon" @click="editBriefNote()">
                      edit
                    </v-icon>
                  </v-flex>
                </v-layout>
                <v-layout v-if="isEditBreifNote">
                  <v-card class="pa-2" :width="900">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-textarea
                          class="mt-0 pa-0"
                          auto-grow
                          :placeholder="$t('message.bizgainOnboarding.briefNote')"
                          rows="1"
                          v-model="briefNote"
                        />
                      </v-flex>
                      <v-flex xs12 md3>
                        <v-btn
                          depressed
                          :loading="isUpdateBriefNote"
                          class="mx-0 next-btn-color next-btn-xs"
                          @click="updateBriefNote()"
                        >
                          {{ $t('message.save') }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <v-dialog
        persistent
        v-model="locationTargetingDialog"
        v-if="locationTargetingDialog"
        content-class="edit-dialog"
        :max-width="`${$vuetify.breakpoint.smAndDown ? '90vw' : '650px'}`"
      >
        <edit-location-targeting-details
          @updateLocationtargetingDetails="updateLocationtargetingDetails"
          @update="updateLocationTargeting"
          @closeDialog="closeTargetingDialog"
        />
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  VLayout,
  VFlex,
  VIcon,
  VBtn,
  VCard,
  VRangeSlider,
  VTextarea,
  VDialog
} from 'vuetify/lib';
import { bizgainOnboardingRoutes, genderTypes, targetType, ageSliderLabel, radiuses, distanceUnit } from 'Features/bizgainOnboarding/constants';
import { mapGetters, mapActions } from 'vuex';
import { i18n } from '@/lang/';
import ImageCardRow from 'Components/ImageCardRow/ImageCardRow.vue';
import editLocationTargetingDetails from '../dailogs/editLocationTargetingDetails.vue';
import Bugsnag from '@bugsnag/js';

export default {
  components: {
    VLayout,
    VFlex,
    VIcon,
    VBtn,
    VCard,
    VRangeSlider,
    VTextarea,
    ImageCardRow,
    VDialog,
    editLocationTargetingDetails
  },
  data(){
    return {
      bizgainOnboardingRoutes,
      genderTypes,
      briefNote: null,
      targetingGender: null,
      targetingAgeRange: [],
      targetingLocation: '',
      targetType,
      targetingType: null,
      radiuses,
      placeDetails: null,
      isValid: false,
      location: null,
      selectedSpecificLocations: [],
      distanceUnit: distanceUnit.kiloMeters,
      age: ageSliderLabel,
      isUpdateGender: false,
      newBusinessDetails: null,
      isEditGender: false,
      isEditAge: false,
      isUpdateAge: false,
      isEditBreifNote: false,
      isUpdateBriefNote: false,
      locationTargetingDialog: false
    }
  },
  created(){
    if(this.businessDetails){
      this.briefNote = this.businessDetails.briefNote ? this.businessDetails.briefNote : '-';
    }
    if(this.businessDetails && this.businessDetails.targeting){
      this.targetingGender = this.businessDetails.targeting.gender;
      this.targetingLocation = this.businessDetails.targeting.location.googlePlaceName;
      this.targetingAgeRange.push(this.getAgeIndex(this.businessDetails.targeting.age.minimum));
      this.targetingAgeRange.push(this.getAgeIndex(this.getMaxAge(this.businessDetails.targeting.age.maximum)));
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'isError']),

    targetingAgeString () {
      if(this.businessDetails && this.businessDetails.targeting && this.businessDetails.targeting.age && this.businessDetails.targeting.age.minimum >= 18){
        let maxAge = this.businessDetails.targeting.age.maximum;
        maxAge = maxAge == '65+' ? 100 : maxAge == 100 ? '65+' : maxAge;
        return this.businessDetails.targeting.age.minimum + ' - ' + maxAge;
      }
      return '';
    },
    gender () {
      switch(this.targetingGender) {
        case this.genderTypes.all.id:
          return i18n.tc('message.bizgainOnboarding.all');
        case this.genderTypes.male.id:
          return i18n.tc('message.bizgainOnboarding.onlyMen');
        case this.genderTypes.female.id:
          return i18n.tc('message.bizgainOnboarding.onlyWomen');
        default:
          return '';
      }
    },
    targetingLocationString() {
      if(this.businessDetails && this.businessDetails.targeting && this.businessDetails.targeting.location){
        if(this.businessDetails.targeting.location.type == this.targetType.latlng){
          return this.businessDetails.targeting.location.radius + ' Km around, ' + this.businessDetails.targeting.location.googlePlaceName;
        }else if(this.businessDetails.targeting.location.type == this.targetType.region){
          let regions = [];
          this.businessDetails.targeting.location.regions.map((region) => {
            regions.push(region.completePath);
          });
          return regions.join(' | ');
        }
      }
      return '-';
    }
  },
  methods: {
    ...mapActions(['patchBusinessDetails']),
    getAgeIndex(age){
      return this.age.indexOf(age.toString());
    },
    getMaxAge(age) {
      return age == '65+' ? 100 : age == 100 ? '65+' : age
    },
    goToTargetAgeGender() {
      this.$router.push({ name: this.bizgainOnboardingRoutes.AgeGenderTarget.name, params: { isAppFlow: true, fromSummary: true, scroll: 'targeting' } });
    },
    goToLocationTargeting() {
      this.$router.push({ name: this.bizgainOnboardingRoutes.LocationTargeting.name, params: { isAppFlow: true, fromSummary: true, scroll: 'targeting' } });
    },
    editLocationtargeting(){
      this.locationTargetingDialog = true;
    },
    updateSelectedGender(type) {
      this.targetingGender = type;
    },
    editGender(){
      this.isEditGender = true;
    },
    async updateGender() {
      if (this.targetingGender && !this.isUpdateGender) {
        try {
          this.isUpdateGender = true;
          if (this.businessDetails) {
            this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
            if(this.businessDetails.targeting){
              this.newBusinessDetails.targeting.gender = this.targetingGender;
            }
            else{
              this.newBusinessDetails.targeting = { age: { minimum: this.age[this.targetingAgeRange[0]], maximum: this.getMaxAge(this.age[this.targetingAgeRange[1]]) }, gender: this.targetingGender };
            }
            let payload = {
              sessionId: this.businessDetails.sessionId,
              oldBusinessDetails: this.businessDetails,
              newBusinessDetails: this.newBusinessDetails
            };
            await this.patchBusinessDetails(payload);
          }
        } catch(error) {
          Bugsnag.notify(error);
        }finally{
          this.isUpdateGender = false;
          this.isEditGender = false;
        }
      }
    },
    editTargetingAge(){
      this.isEditAge = true;
    },
    async updateAge(){
      if (this.businessDetails && !this.isUpdateAge) {
        try {
          this.isUpdateAge = true;
          if (this.businessDetails) {
            this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
            let age =  {
              minimum: this.age[this.targetingAgeRange[0]],
              maximum: this.getMaxAge(this.age[this.targetingAgeRange[1]])
            };
            if(this.newBusinessDetails && this.newBusinessDetails.targeting){
              this.newBusinessDetails.targeting.age = age;
            }
            else{
              this.newBusinessDetails.targeting = { age: { minimum: this.age[this.targetingAgeRange[0]], maximum: this.getMaxAge(this.age[this.targetingAgeRange[1]]) }, gender: 0 };
            }

            let payload = {
              sessionId: this.businessDetails.sessionId,
              oldBusinessDetails: this.businessDetails,
              newBusinessDetails: this.newBusinessDetails
            };
            await this.patchBusinessDetails(payload);
          }
        } catch(error) {
          Bugsnag.notify(error);
        }
        finally{
          this.isUpdateAge = false;
          this.isEditAge = false;
        }
      }
      this.isUpdateAge = false;
    },
    editBriefNote(){
      if(!this.businessDetails.briefNote){
        this.briefNote = null;
      }
      this.isEditBreifNote = true;
    },
    async updateBriefNote(){
      try {
        if (this.businessDetails && this.briefNote) {
          this.isUpdateBriefNote = true;
          this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
          this.newBusinessDetails.briefNote = this.briefNote;
          let payload = {
            sessionId: this.businessDetails.sessionId,
            oldBusinessDetails: this.businessDetails,
            newBusinessDetails: this.newBusinessDetails
          };
          await this.patchBusinessDetails(payload);
        }else{
          this.briefNote = '-';
        }
      } catch(error) {
        Bugsnag.notify(error);
      }
      finally{
        this.isUpdateBriefNote = false;
        this.isEditBreifNote = false;
      }
    },
    editTargetingLocationDetails(){
      this.locationTargetingDialog = true;
    },
    updateLocationtargetingDetails(details){
      this.targetingType = details.targetingType;
      this.placeDetails = details.placeDetails;
      this.isValid = details.isValid;
      this.selectedRadius = details.selectedRadius;
      this.distanceUnit = details.distanceUnit;
      this.selectedSpecificLocations = details.selectedSpecificLocations;
      this.location = details.location;
    },
    closeTargetingDialog(){
      this.locationTargetingDialog = false;
    },
    async updateLocationTargeting() {
      if (this.isValid) {
        let locationTargeting = {};
        switch(this.targetingType) {
          case this.targetType.latlng:
            if (this.placeDetails) {
              locationTargeting.googlePlaceId = this.placeDetails.placeId;
              locationTargeting.googlePlaceName = this.placeDetails.name;
              if (this.placeDetails.location) {
                locationTargeting.latitude =  this.placeDetails.location.latitude;
                locationTargeting.longitude = this.placeDetails.location.longitude;
              }
              if (this.placeDetails.addressComponents &&
              Array.isArray(this.placeDetails.addressComponents) &&
              this.placeDetails.addressComponents.length > 0)
              {
                let zipCodeData = this.placeDetails.addressComponents.find(addressComponent => addressComponent.types.includes('postal_code'));
                if (zipCodeData) {
                  locationTargeting.zipCode = zipCodeData.longName;
                }
              }
            }
            locationTargeting.type = this.targetType.latlng;
            locationTargeting.radius = this.selectedRadius;
            locationTargeting.units = this.distanceUnit;
            locationTargeting.regions = [];
            break;
          case this.targetType.region:
            locationTargeting.type = this.targetType.region;
            if (Array.isArray(this.selectedSpecificLocations) && this.selectedSpecificLocations.length < 0) {
              return;
            }
            let values = this.selectedSpecificLocations.map(x => x.value);
            if (Array.isArray(values) && values.length > 0) {
              locationTargeting.regions = values;
            }
            break;
        }
        if(this.businessDetails){
          this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
          if (this.newBusinessDetails && this.newBusinessDetails.targeting) {
            this.newBusinessDetails.targeting.location = locationTargeting;
          }
          else {
            this.newBusinessDetails.targeting = { age: { minimum: this.age[this.targetingAgeRange[0]], maximum: this.getMaxAge(this.age[this.targetingAgeRange[1]]) }, gender: this.targetingGender, location: locationTargeting   };;
          }
          try{
            let payload = {
              sessionId: this.businessDetails.sessionId,
              oldBusinessDetails: this.businessDetails,
              newBusinessDetails: this.newBusinessDetails
            };
            await this.patchBusinessDetails(payload);
          }
          catch(error){
            Bugsnag.notify(error);
          }
          finally{
            this.locationTargetingDialog = false;
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.line{
  width: 28%;
  border-bottom: solid;
  border-bottom-color: #54B4D3;
}
.section-header{
  display: flex;
  align-content: center;
}
.header-label{
  padding-top: 2px !important;
}
.greyIcon{
  color: #727891;
}
.themedIcon{
  color: #13abb1;
}
.editIcon{
  color: #13abb1;
}
.detail-field{
  color: black;
  align-self: center;
}
.custom-card-content{
  padding-bottom: 0 !important;
}
@media only screen and (max-width: 600px) {
  .editIcon{
    color: #727891;
  }
}

::v-deep .age-range-slider{
  .v-slider{
    z-index:0;
    .v-slider__ticks{
      color:var(--v-primary-variation-1-base) !important;
      border-color: var(--v-primary-variation-1-base) !important;
      border-left: 1px solid !important;
      border-right: 0.5px solid !important;
      height: 14px;
      position: absolute;
      left: 50%;
      margin-left: -3px;
      top: -5px;
      span {
        color:var(--v-black-base) !important;
        position: absolute;
        top: 18px;
      }
    }
    .v-slider__ticks:first-child {
      span{
        left: -9px;
      }
    }
    .v-slider__ticks:last-child {
      span{
        left:15px;
      }
    }
    .v-slider__track__container{
      left: -3px !important;
      z-index:1 !important;
    }
    .v-slider__thumb{
      z-index:2 !important;
    }
    .v-slider__thumb-container{
      top:-25%;
      display: inline-block;
      padding: 24px 24px 24px 0;
    }
    .v-slider__thumb-container::before{
      top:15%;
    }
  }
}

.brief {
  padding-bottom: 4px !important;
}

</style>

